import React,{useState,}from 'react'
import { Modal,Form,message, Input,} from 'antd';
import GetUserDept from '../../cpn/GetUserDept';
import { PlusSquareOutlined } from '@ant-design/icons';
import { useBnsXiangMuAddMutation } from '../../store/BnsKeJiApi';
import MyEditor from '../../cpn/MyEditor';
function ProjectAdd(props) {    
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);   
    const [info,setInfo] = useState({
        bxm_content:'',
        bxm_name:'',
    })
    const [add] = useBnsXiangMuAddMutation()
    
    return (
            <>
                <a onClick={() => {setOpen(true)}}><PlusSquareOutlined /> 新增项目</a>
                <Modal
                    width={1000}
                    open={open}
                    title='新增项目'
                    okText="提交"
                    cancelText="取消"
                    onCancel={() => {setOpen(false);}}
                    onOk={() => {
                        form
                            .validateFields()
                            .then((values) => {
                                form.resetFields();    
                                add({
                                    bxm_e_id:props.e_id,
                                    bxm_dept_id:info.bxm_dept_id,
                                    bxm_dept_name: info.bxm_dept_name,
                                    bxm_name:info.bxm_name,
                                    bxm_content:info.bxm_content,
                                    bxm_cid: props.eu_id,
                                    bxm_cname: props.eu_name,
                                }).then((res) => {
                                    if (res.data.Status === 'success') {
                                        message.info('新增成功！');
                                        setOpen(false);
                                    }
                                    if (res.data.Status === "fail") {
                                        message.error('新增失败！'+res.data.Message)
                                    }
                                })                              
                            })
                            .catch((info) => {
                                console.log('Validate Failed:', info);
                            });                    
                    }}
                >
                    <Form
                        form={form}
                        layout="horizonal"
                        name="form_client_add"
                        initialValues={{modifier: 'public',}}
                        labelCol={{ span: 3 }}
                    >
                        <GetUserDept 
                            label='部门'
                            required
                            wrapperCol={{span:10}} 
                            getUserDept={(e,f) => {
                                setInfo(prevState=>({...prevState,bxm_dept_id:e,bxm_dept_name:f}))
                            }}
                        />
                        <Form.Item 
                            name="bxm_name" 
                            label='项目名称' 
                            wrapperCol={{span:20}} 
                            required
                        >
                            <Input 
                                onChange={(e) => {setInfo(prevState=>({...prevState,bxm_name:e.target.value}))}}
                            />
                        </Form.Item> 
                       <Form.Item 
                            name="bxm_content" 
                            label='项目说明' 
                            wrapperCol={{span:21}}                            
                        >
                            <MyEditor  onChange={(e) => {setInfo(prevState=>({...prevState,bxm_content:e}))}}/>
                        </Form.Item>                                           
                    </Form>
                </Modal>                
            </>
        )
}

export default ProjectAdd